/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserWalletCreateReqVo
 */
export interface UserWalletCreateReqVo {
    /**
     * 用户 ID，关联用户表主键，必传
     * @type {number}
     * @memberof UserWalletCreateReqVo
     */
    userId: number;
    /**
     * 钱包余额，初始金额，必须大于等于 0，必传
     * @type {number}
     * @memberof UserWalletCreateReqVo
     */
    amount: number;
    /**
     * 货币代码，如 CNY、USD、KRW 等，必传
     * @type {string}
     * @memberof UserWalletCreateReqVo
     */
    currencyCode: string;
    /**
     * 冻结金额，初始冻结金额，必须大于等于 0，必传
     * @type {number}
     * @memberof UserWalletCreateReqVo
     */
    freezeAmount: number;
    /**
     * 是否可用：0-不可用，1-可用，默认可用，必传
     * @type {number}
     * @memberof UserWalletCreateReqVo
     */
    enable: number;
    /**
     * 钱包类型：1-韩国钱包（默认），2-中国账单钱包
     * @type {number}
     * @memberof UserWalletCreateReqVo
     */
    walletType?: number;
}

/**
 * Check if a given object implements the UserWalletCreateReqVo interface.
 */
export function instanceOfUserWalletCreateReqVo(value: object): value is UserWalletCreateReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('freezeAmount' in value) || value['freezeAmount'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    return true;
}

export function UserWalletCreateReqVoFromJSON(json: any): UserWalletCreateReqVo {
    return UserWalletCreateReqVoFromJSONTyped(json, false);
}

export function UserWalletCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWalletCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'amount': json['amount'],
        'currencyCode': json['currencyCode'],
        'freezeAmount': json['freezeAmount'],
        'enable': json['enable'],
        'walletType': json['walletType'] == null ? undefined : json['walletType'],
    };
}

export function UserWalletCreateReqVoToJSON(json: any): UserWalletCreateReqVo {
    return UserWalletCreateReqVoToJSONTyped(json, false);
}

export function UserWalletCreateReqVoToJSONTyped(value?: UserWalletCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'amount': value['amount'],
        'currencyCode': value['currencyCode'],
        'freezeAmount': value['freezeAmount'],
        'enable': value['enable'],
        'walletType': value['walletType'],
    };
}

